import { ChipClassKey } from '@material-ui/core/Chip';
import { Theme } from '@material-ui/core/styles';
import tokens from '../tokens';

const MuiChip = (theme: Theme): Partial<Record<ChipClassKey, unknown>> => ({
    /* Styles applied to the root element. */
    root: {
        borderRadius: tokens.radii.semiRounded,
        color: theme.palette.grey[500],
        verticalAlign: 'baseline',
    },
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
        height: 18,
    },
    /* Styles applied to the `icon` element if `size="small"`. */
    iconSmall: {
        fontSize: 18,
        marginLeft: 4,
        marginRight: -4,
    },
    /* Styles applied to the `deleteIcon` element if `size="small"`. */
    deleteIconSmall: {
        fontSize: 16,
        marginRight: 4,
        marginLeft: -4,
    },
});

export default MuiChip;
